import * as types from './actionTypes';
import axios from 'axios';
import config from '../../config';
import * as documentsUtil from '../../shared/documentUtil';
export const actionCreators = {
	checkIfIDVerificationIsEnabled: () => async (dispatch) => {
		try {

			const response = await axios.get(
				`${config.apiUrl}/api/access/id-verification`
			);

			const enabled = response.data;
			dispatch({ type: types.idVerificationIsEnabled, enabled: enabled });
			return enabled;
		} catch (error) {
			var response = error.response;

			dispatch({
				type: types.idVerificationIsEnabled,
				error: response ? response.data : 'Failed to check if user requires ID verification.',
			});
		}
	},
	getVerificationSession: (changeRequestID, documentID) => async (dispatch) => {
		try {

			const response = await axios.get(
				`${config.apiUrl}/api/entities/${changeRequestID}/id-verification-session/${documentID}`
			);

			dispatch({ type: types.idVerificationSession });
			return response;
		} catch (error) {
			var response = error.response;

			dispatch({
				type: types.idVerificationSession,
				error: response ? response.data : 'Failed to retrieve verification session.',
			});
		}
	},
	requestEntities: (forceRequest = false) => async (dispatch, getState) => {
		const entities = getState().selfService.entities;
		if (!forceRequest && entities.length) {
			return;
		}

		dispatch({ type: types.getEntities });

		try {
			const response = await axios.get(`${config.apiUrl}/api/entities`);

			const entities = response.data;
			dispatch({ type: types.getEntitiesSuccess, entities });
		} catch (error) {
			var response = error.response;

			dispatch({
				type: types.selfServiceApiRequestError,
				error: response ? response.data : 'Failed to retrieve entities.',
			});
		}
	},
	requestEntityFields: (entityChangeRequestId, forceRequest = false) => async (dispatch, getState) => {
		const activeEntity = getState().selfService.activeEntity;

		if (!forceRequest && activeEntity && entityChangeRequestId === activeEntity.EntityChangeRequestID) {
			return;
		}

		dispatch({ type: types.getEntityFields });

		try {
			const response = await axios.get(`${config.apiUrl}/api/entities/ignore/${entityChangeRequestId}/fields`);

			const entity = response.data;

			dispatch({
				type: types.getEntityFieldsSuccess,
				entity,
			});
			return entity;
		} catch (error) {
			dispatch({
				type: types.selfServiceApiRequestError,
				error: error.response ? error.response.data : 'Failed to retrieve entity fields.',
			});
		}
	},
	reloadEntityFields: (entityChangeRequestId) => async (dispatch, getState) => {
		dispatch({ type: types.reloadEntityFields });

		try {
			const response = await axios.get(
				`${config.apiUrl}/api/entities/ignore/${entityChangeRequestId}/fields` //john-smith
			);

			const reloadedEntity = response.data;

			if (!reloadedEntity.EntityFields) {
				return;
			}

			function compareFieldGroups(activeFields, reloadedFields) {
				function comparer(otherArray) {
					return function (current) {
						return (
							otherArray.filter(function (other) {
								return other.FieldCode === current.FieldCode;
							}).length === 0
						);
					};
				}

				var onlyInA = reloadedFields.filter(comparer(activeFields));
				var onlyInB = activeFields.filter(comparer(reloadedFields));
				return onlyInA.concat(onlyInB);
			}

			var newEntityFields = {};

			var activeEntity = getState().selfService.activeEntity;
			newEntityFields.EntityFields = compareFieldGroups(activeEntity.EntityFields, reloadedEntity.EntityFields);
			newEntityFields.CustomFields = compareFieldGroups(activeEntity.CustomFields, reloadedEntity.CustomFields);
			newEntityFields.DocumentTypes = compareFieldGroups(activeEntity.DocumentTypes, reloadedEntity.DocumentTypes);
			newEntityFields.RelatedCountryTypes = compareFieldGroups(activeEntity.RelatedCountryTypes, reloadedEntity.RelatedCountryTypes);
			// id upload mandatory
			newEntityFields.IdentificationDocumentsRequireUpload = !activeEntity.IdentificationDocumentsRequireUpload && reloadedEntity.IdentificationDocumentsRequireUpload;

			dispatch({
				type: types.reloadEntityFieldsSuccess,
				reloadedEntity,
				newEntityFields,
			});

			return Promise.resolve(reloadedEntity);
		} catch (error) {
			dispatch({
				type: types.selfServiceApiRequestError,
				error: error.response ? error.response.data : 'Failed to retrieve entity fields.',
			});
			return Promise.reject();
		}
	},
	submitEntityFields: (entity, fields) => async (dispatch) => {
		dispatch({ type: types.submitEntity });
		try {
			await axios.post(`${config.apiUrl}/api/entities/ignore/${entity.EntityChangeRequestID}/fields`, fields);

			dispatch({
				type: types.submitEntitySuccess,
				message: `Entity data for "${entity.EntityName}" has been submitted for review.`,
			});
			return Promise.resolve();
		} catch (error) {
			dispatch({
				type: types.selfServiceApiRequestError,
				error: error.response ? error.response.data : 'Failed to submit entity fields.',
			});
			return Promise.reject();
		}
	},
	saveEntityFields: (entity, fields) => async (dispatch) => {
		dispatch({ type: types.saveEntity });

		try {
			await axios.post(`${config.apiUrl}/api/entities/ignore/${entity.EntityChangeRequestID}/save-fields`, {
				...fields,
				Comments: [],
			});

			dispatch({ type: types.saveEntitySuccess });
			return Promise.resolve();
		} catch (error) {
			dispatch({
				type: types.selfServiceApiRequestError,
				error: error.response ? error.response.data : 'Failed to save entity fields.',
			});

			return Promise.reject(error.response.data ? error.response.data : error.response);
		}
	},
	setActiveEntityModified: (isModified) => async (dispatch, getState) => {
		if (!getState().selfService.isActiveEntityModified) {
			dispatch({ type: types.setActiveEntityFieldModified, isModified });
		}
	},
	setActiveEntityFieldErrors: (errors) => async (dispatch) => {
		dispatch({ type: types.setActiveEntityFieldErrors, errors });
	},
	clearActiveEntityFieldError: (fieldCode, section) => async (dispatch, getState) => {
		var errors = { ...getState().selfService.activeEntityFieldErrors };

		if (errors[section] && errors[section].some(x => x.FieldCode === fieldCode)) {
			errors[section] = errors[section].filter(x => x.FieldCode !== fieldCode);
			dispatch({ type: types.clearActiveEntityFieldError, errors });
		}
	},
	updateIdentificationDocumentField: (idDocument, fieldName, value) => (dispatch) => {
		dispatch({
			type: types.updateIdentificationDocumentField,
			idDocument: idDocument,
			fieldName: fieldName,
			value: value
		});
	},
	addIdentificationDocument: (idDocument) => async (dispatch) => {
		dispatch({
			type: types.addIdentificationDocument,
			newIdentificationDocument: idDocument
		});
	},
	setIdVerificationSkipped: (skipped) => async (dispatch) => {
		dispatch({
			type: types.idVerificationSkipped,
			skipped: skipped
		});
	},
	//requestUserAccounts: (userId) => async (dispatch, getState) => {
	//	dispatch({type: types.getUserAccounts});

	//	try {
	//		// WIP: GET DATA FROM API

	//		// WIP: REMOVE FAKE DATA
	//		const userAccounts = [
	//			{
	//				provider: 'Microsoft',
	//				email: '01/01/1990',
	//			},
	//			{
	//				provider: 'Google',
	//				email: '01/01/1990',
	//			},
	//			{
	//				provider: 'Facebook',
	//				email: '01/01/1990',
	//			},
	//		];

	//		dispatch({type: types.getUserAccountsSuccess, userAccounts});
	//	} catch (error) {
	//		var response = error.response;

	//		dispatch({
	//			type: types.selfServiceApiRequestError,
	//			error: response ? response.data : 'Failed to retrieve entity accounts.',
	//		});
	//	}
	//},
	setEntitiesInitialRequestStatus: (initialEntitiesRequest) => async (dispatch) => {
		dispatch({ type: types.setEntitiesInitialRequestStatus, initialEntitiesRequest });
	},
	setExpandedSections: (expandedSections) => async (dispatch) => {
		dispatch({ type: types.setExpandedSections, expandedSections });
	},
	requestDocument: (entityChangeRequestID, documentId) => async (dispatch) => {
		dispatch({ type: types.downloadDocument });
		try {
			const response = await axios({
				method: 'GET',
				url: `${config.apiUrl}/api/entities/ignore/${entityChangeRequestID}/download-document/${documentId}`,
				responseType: 'arraybuffer',
			});
			documentsUtil.downloadDocument(response);
			dispatch({ type: types.downloadDocumentSuccess });

			return Promise.resolve();
		} catch (error) {
			var message = error.response ? documentsUtil.convertBufferedMessageToString(error.response.data)
				: 'Failed to download file.';

			dispatch({
				type: types.selfServiceApiRequestError,
				error: message
			});

			return Promise.reject(message);
		}
	},
	deleteDocument: (entityChangeRequestID, fieldCode, documentID) => async (dispatch, getState) => {
		dispatch({ type: types.deleteDocument });
		try {
			await axios.post(`${config.apiUrl}/api/entities/ignore/${entityChangeRequestID}/delete-document/${documentID}`);
			const currentDocumentTypes = getState().selfService.activeEntity.DocumentTypes;
			const docTypeIndex = currentDocumentTypes.findIndex((doc) => doc.FieldCode === fieldCode);

			const newDocumentTypes = Object.assign([], currentDocumentTypes, {
				[docTypeIndex]: {
					...currentDocumentTypes[docTypeIndex],
					SelfServiceDocuments: [
						...currentDocumentTypes[docTypeIndex].SelfServiceDocuments.filter(
							(doc) => doc.BaseDocumentId !== documentID
						),
					],
				},
			});
			dispatch({ type: types.deleteDocumentSuccess, DocumentTypes: newDocumentTypes });

			return Promise.resolve();
		} catch (error) {
			dispatch({
				type: types.selfServiceApiRequestError,
				error: error.response ? error.response.data : 'Failed to delete file.',
			});

			return Promise.reject(error.response ? error.response.data : 'Failed to delete file.');
		}
	},
	uploadDocument: (entityChangeRequestID, fieldCode, file, docV2) => async (dispatch, getState) => {
		dispatch({ type: types.uploadDocument });
		const dataAsString = await documentsUtil.toBase64(file);
		docV2.Data = dataAsString.split(',')[1].trim();
		docV2.DocumentName = docV2.UploadedFileName;

		try {
			const response = await axios.post(
				`${config.apiUrl}/api/entities/ignore/${entityChangeRequestID}/add-document`,
				docV2
			);
			const currentDocumentTypes = getState().selfService.activeEntity.DocumentTypes;

			const docToBeAdded = {
				BaseDocumentId: response.data,
				FileName: fieldCode,
				FileExtension: docV2.Extension,
				IsSelfService: true,
				UploadedFileName: docV2.UploadedFileName,
			};
			const docType = currentDocumentTypes.find((doc) => doc.DocumentTypeID.toString() === docV2.DocumentTypeID);
			const documentTypeIdIndex = currentDocumentTypes.findIndex(
				(doc) => doc.DocumentTypeID.toString() === docV2.DocumentTypeID
			);
			const newDocType = {
				[documentTypeIdIndex]: { ...docType, SelfServiceDocuments: [...docType.SelfServiceDocuments, docToBeAdded] },
			};

			const newDocumentTypes = Object.assign([], currentDocumentTypes, {
				[documentTypeIdIndex]: {
					...currentDocumentTypes[documentTypeIdIndex],
					SelfServiceDocuments: [...docType.SelfServiceDocuments, docToBeAdded],
				},
			});

			dispatch({ type: types.uploadDocumentSuccess, DocumentTypes: newDocumentTypes });

			return Promise.resolve();
		} catch (error) {
			dispatch({
				type: types.selfServiceApiRequestError,
				error: error.response ? error.response.data : 'Failed to upload file.',
			});

			return Promise.reject(error.response ? error.response.data : 'Failed to upload file.');
		}
	},

	downloadDocumentTypeTemplate: (entityChangeRequestID, documentTypeID) => async (dispatch, getState) => {

		dispatch({ type: types.downloadingDocumentTypeTemplate });
		const response = await GET_DownloadDocumentTypeTemplate(entityChangeRequestID, documentTypeID);
		dispatch({ type: types.downloadingDocumentTypeTemplateSuccess });
		return response;

	},

	uploadIdentificationDocument: (entityChangeRequestID, docV2) => async (dispatch, getState) => {
		dispatch({ type: types.uploadingIdentificationDocument });
		const response = await POST_AddDocumentV2(entityChangeRequestID, docV2);
		dispatch({ type: types.uploadIdentificationDocumentSuccess });
		return response;
	},

	deleteIdentificationDocument: (entityChangeRequestID, documentID) => async (dispatch, getState) => {
		dispatch({ type: types.deletingIdentificationDocument });
		const response = await POST_DeleteIdentificationDocument(entityChangeRequestID, documentID);
		dispatch({ type: types.deleteIdentificationDocumentSuccess });
		return response;
	},

	requestIdentificationDocument: (entityChangeRequestID, documentID) => async (dispatch) => {
		dispatch({ type: types.downloadingIdentificationDocument });
		const response = await GET_DownloadIdentificationDocument(entityChangeRequestID, documentID);
		dispatch({ type: types.downloadIdentificationDocumentSuccess });
		return response;
	},

	getAllIdentificationDocumentTypes: () => async (dispatch) => {
		dispatch({ type: types.gettingIdentificationDocumentTypes, gettingIdentificationDocumentTypes: true });
		const response = await GET_IdentificationDocumentTypes();
		dispatch({ type: types.gettingIdentificationDocumentTypes, gettingIdentificationDocumentTypes: false });
		return response;
	},
};


//REQUESTS TO THE API FROM HERE -- NEW APPROACH
const POST_AddDocumentV2 = async (entityChangeRequestId, docV2) => {
	try {
		return await axios.post(URL_POST_addDocumentV2(entityChangeRequestId), docV2);
	} catch (error) {
		return { requestError: error };
	}
};

const GET_IdentificationDocumentTypes = async () => {
	try {
		return await axios.get(URL_GET_IdentificationDocumentTypes());
	} catch (error) {
		return { requestError: error };
	}
};

const GET_DownloadIdentificationDocument = async (entityChangeRequestID, documentID) => {
	try {
		return await axios.get(URL_GET_DownloadIdentificationDocument(entityChangeRequestID, documentID), { responseType: 'blob' });
	} catch (error) {
		return { requestError: error };
	}
};
const POST_DeleteIdentificationDocument = async (entityChangeRequestID, documentID) => {
	try {
		return await axios.post(URL_POST_DeleteIdentificationDocument(entityChangeRequestID, documentID));
	} catch (error) {
		return { requestError: error };
	}
};

const GET_DownloadDocumentTypeTemplate = async (entityChangeRequestID, documentTypeID) => {
	try {
		return await axios({
			method: 'GET',
			url: URL_GET_DownloadDocumentTypeTemplate(entityChangeRequestID, documentTypeID),
			responseType: 'arraybuffer',
		});
	} catch (error) {
		return { requestError: error };
	}
};




//REQUEST URLs HERE -- NEW APPROACH
const URL_POST_addDocumentV2 = (entityChangeRequestID) =>
	`${config.apiUrl}/api/entities/ignore/${entityChangeRequestID}/add-document`;

const URL_GET_IdentificationDocumentTypes = () => `${config.apiUrl}/api/static-data/identification-document-types`;

const URL_GET_DownloadIdentificationDocument = (entityChangeRequestID, documentID) => `${config.apiUrl}/api/entities/ignore/${entityChangeRequestID}/download-id-document/${documentID}`;

const URL_POST_DeleteIdentificationDocument = (entityChangeRequestID, documentID) => `${config.apiUrl}/api/entities/ignore/${entityChangeRequestID}/delete-document/${documentID}`

const URL_GET_DownloadDocumentTypeTemplate = (entityChangeRequestID, documentTypeID) => `${config.apiUrl}/api/entities/ignore/${entityChangeRequestID}/download-document-type-template/${documentTypeID}`